import React from "react";
import {EditorialReport,analysisGrade} from "./triproutes-editorial-report.jsx";
export function RevisionFeedbackDetails({feedback:f,cities=false}){
 if(!f)return null;
 if(f.state==="not_required")return <p>Вторая модель не вызывалась: оценка Jev проходит порог и нет hard_fail.</p>;
 if(f.state==="unavailable")return <p role="status">{f.unavailableReason||"Оценка Jev сохранена; подробный разбор второй модели не завершён."}</p>;
 if(f.state==="structural")return <p>Обнаружена структурная ошибка. Конкретные замечания переданы без дополнительного вызова модели.</p>;
 return <section aria-label="Разбор перед возвратом"><h4>{f.model}: {analysisGrade(f.result)}/10</h4><p>Дополнительная оценка поясняет, что исправить. {cities?"Карточка города не меняется; все замечания сохраняются в Harness.":"Решение о возврате принято по оценке Jev и hard_fail."}</p><EditorialReport result={f.result}/></section>;
}
export function RevisionFeedbackGrade({feedback:f}){
 if(!f)return null;
 return <><div><strong>Jev: {f.screening.score}/10{f.screening.hard_fail?" · hard_fail":""}</strong></div><div>{f.result?<strong>{f.model}: {analysisGrade(f.result)}/10</strong>:<small>{f.model}: {f.state==="unavailable"?"разбор не завершён":"без вызова"}</small>}</div></>;
}
export function RevisionFeedbackSummary({feedback:f}){
 return f?.result?.editorial?.summary?<p>{f.result.editorial.summary}</p>:null;
}
